import * as HANDLERS from '@/helpers/types/handlers';
import { reports } from '@/helpers/types/reports';
import { Decrypt, downloadFile, formatEntry, formatEntryFromEntryFields, setPagesToClearDefaultFilter, tabHeaderHasResetDefaultFilter, filterDataAccordingPageMode, filterData } from '@/helpers/utils';
import router from '@/router';
import ECM from '@/services/ecm';
import pageServices from '@/services/page';
import reportServices from '@/services/report';
import store from '@/store';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import eventBus from 'vue-option-events';
import XLSX from 'xlsx';

export const compareProps = (a, b) => Object.keys(a).every(key => b.hasOwnProperty(key));

export const compare = (a, b) => JSON.stringify(a) === JSON.stringify(b);

export const handleLoadRoute = async (item, prevPage = null) => {
  if ('children' in item) return;

  const { id, page, mode, redirect, redirectParams, parameters, procedure, notification} = item;
  store.commit('page/resetPageFilter');
  store.dispatch('page/resetDefaultFilter');
  eventBus.$emit(HANDLERS.CLOSE_DRAWER_DINAMIC);
  store.dispatch('menu/setCurrentActiveMenu', id);
  store.dispatch('page/setMain', page);
  store.dispatch('breadcrumbs/setBreadcrumbs', { obj: item });

  if (redirect) {
    let pathRegex = /(http:\/\/)|(https:\/\/)/g;

    if (pathRegex.test(redirect)) {
      window.open(redirect, '_blank');
    } else if (router.history.current.name !== redirect) {
      if (redirect === 'dashboard') {
        store.dispatch('module/setDefaultModule', store.getters['module/getDefaultModule']);
      } else {
        router.push({ path: redirect });
      }
    }

    return;
  }

  eventBus.$emit(HANDLERS.CLOSE_DRAWER_DINAMIC);

  await loadRoute({
    page,
    mode,
    redirectParams: parameters ? formatEntry(parameters) : redirectParams,
    procedure,
    target: 'page',
    notification,
    prevPage
  });
};

export const loadRoute = async params => {
  const { origin, page, mode, target, rootLevel, notification } = params;

  const notificationMode = store.getters['layout/getConfigLayout']?.notification || false
  if (notificationMode && notificationMode === 'alert') {
    store.dispatch('notification/getAllNotifications')
  }

  if (params.breadCrumbs) {
    await store.dispatch('breadcrumbs/setBreadcrumbs', {
      obj: params.breadCrumbs,
      dashboardNome: params.dashboardNome
    });
  }

  if (origin) {
    if ((origin !== page && target == 'page') || rootLevel) {
      await store.dispatch('page/setMain', page);
      store.dispatch('menu/setCurrentPage', {
        menu: page,
        mode
      });
    }
  } else {
    store.dispatch('menu/setCurrentPage', {
      menu: page,
      mode
    });
  }

  if (window.location.hash !== '#/page') {
    router.push({
      name: 'Page',
      params
    });
  } else {
    await store.dispatch('page/load', params);
  }
};

export const getListIndex = async (page, list, navigation, state) => {
  const keyList = state.schemes[page]['list'].attributes.attributesTable.keyValue;
  let result;

  list.filter((item, index) => {
    if (item[keyList] == state.defaultFilter[page][keyList]) result = navigation == 'previous' ? index - 1 : index + 1;
  });

  return result;
};

export const initLookups = async (commit, state, { mode, page, tab, step }) => {
  if (mode === "subPages") return;
  let form = {};

  if (tab && state.schemes[page][mode].tabs) {
    form = state.schemes[page][mode].tabs.content[tab];
  } else if (step && state.schemes[page][mode].steps) {
    form = state.schemes[page][mode].steps.content[step];
  } else {
    if (mode == 'master') {
      form = state.schemes[page]['form'][mode];
    } else {
      form = state.schemes[page][mode];
    }
  }

  let fields = form.fields || [];

  if (mode !== 'master' && form.groups && form.groups.length > 0) {
    form.groups.filter(group => {
      if (group.fields && group.fields.length > 0) {
        group.fields.map(field => (fields = [...fields, field]));
      }
    });
  }

  let newFields = [];

  for (let param of fields) {
    newFields.push({
      fill: param.fill,
      filledBy: param.filledBy,
      name: param.model,
      InvokeName: param.fieldName,
      procedure: 'procedure' in param ? param.procedure.name : '',
      typeLookup: 'typeLookup' in param ? param.typeLookup : null,
      lookupTextKey: 'lookupTextKey' in param ? param.lookupTextKey : null,
      lookupValueKey: 'lookupValueKey' in param ? param.lookupValueKey : null,
      component: 'component' in param ? param.component : null,
      requestApi: 'requestApi' in param ? param.requestApi : null
    });
  }

  const { data } = await pageServices.initLookups({ model: state.models[page][mode], fields: newFields, page });

  for (let item of data.fields.filter(
    x => x.typeLookup && x.typeLookup !== 'conditional' && x.typeLookup !== 'simple'
  )) {
    await commit('setLookup', { data: item, info: { mode, page, tab, step } });
  }
  await commit('updateModel', { page, mode, model: data.model });
};

export const initLookupsList = async (commit, state, { page, items }) => {
  if ('fields' in state.schemes[page].list) {
    let fields = state.schemes[page].list.fields;

    let newFields = [];

    if (!fields.length) return;

    for (let field of fields) {
      newFields.push({
        fill: field.fill,
        filledBy: field.filledBy,
        name: field.model,
        InvokeName: field.fieldName,
        procedure: 'procedure' in field ? field.procedure.name : '',
        typeLookup: 'typeLookup' in field ? field.typeLookup : null,
        requestApi: 'requestApi' in field ? field.requestApi : null
      });
    }

    const { data } = await pageServices.initLookupsList({ model: items, fields: newFields, page });

    let model = [];

    for (let item of data) {
      let key = item.model[state.schemes[page]['list'].attributes.attributesTable.keyValue];
      await commit('setLookupListInit', { items: item.fields, page, key });
      model.push(item.model);
    }

    await commit('updateModelList', { page, mode: 'list', model });
  }
};

export const setLookupListScheme = (commit, state, page) => {
  if ('fields' in state.schemes[page].list) {
    commit('setLookupListScheme', {
      data: state.schemes[page].list.fields,
      info: {
        mode: 'list',
        page
      }
    });
  }
};

export const conditionEngine = async (state, dispatch, { page, mode }) => {
  if (mode !== 'list') {
    if ('tabs' in state.schemes[page][mode] || 'steps' in state.schemes[page][mode]) return;

    await dispatch('conditions', { page, mode });
  }
};

export const lookupEngine = async (commit, state, { page, mode }) => {
  if (mode !== 'list') {
    if ('tabs' in state.schemes[page][mode] || 'steps' in state.schemes[page][mode]) return;

    await initLookups(commit, state, { mode, page });
  }
};

export const showMessage = (commit, { message, color, sweetAlert = false }) => {
  if (sweetAlert) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: `v-btn v-size--default ${color}`
      }
    });

    swalWithBootstrapButtons.fire({
      text: message,
      icon: color
    });

    return;
  }

  if (message) {
    commit(
      'notification/showNotification',
      {
        color: color,
        text: message,
        showIconNotification: false,
        typeAlert: '2',
        typeNotification: '2'
      },
      { root: true }
    );
  }
};

export const setPaths = (scheme, rootState) => {
  if (scheme.background.desktopImage) {
    scheme.background.desktopImage = scheme.background.desktopImage.startsWith('static')
      ? scheme.background.desktopImage
      : rootState.layout.paths[scheme.background.desktopImage];
  }

  if (scheme.background.mobileImage) {
    scheme.background.mobileImage = scheme.background.mobileImage.startsWith('static')
      ? scheme.background.mobileImage
      : rootState.layout.paths[scheme.background.mobileImage];
  }

  return scheme;
};

export const checkParams = (params, commit) => {
  if (!params.page) {
    const { currentPage, currentMode } = JSON.parse(sessionStorage.getItem('i4pro-portal')).menu;
    const redirectParams = JSON.parse(sessionStorage.getItem('i4pro-portal')).page.pageFilter[currentPage];
    JSON.parse(sessionStorage.getItem('i4pro-portal')).page.pageFilter[currentPage]
    eventBus.$emit(HANDLERS.CHANGE_PAGE, { page: currentPage, mode: currentMode });
    params.page = currentPage;
    params.mode = currentMode;
    if (redirectParams)
      params.redirectParams = redirectParams;
    commit('setMain', currentPage);
  }

  return params;
};

export const changeMode = async target => {
  if (target) {
    return target === 'page';
  } else false;
};

export const loadMode = async (state, commit, dispatch, params) => {
  const { page, mode, defaultMode, redirectParams, parent, subPageOf } = params;

  const shouldUsingDefaultMode = (defaultMode !== 'subPages' && !subPageOf)
  let model;

  if (parent != null && Object.keys(state.defaultFilter).length == 0 && 'form' in state.models[parent] && !(params.target == 'dialog')) {
    if (!tabHeaderHasResetDefaultFilter(state.schemes[parent].form, page)) {
      commit('setDefaultFilter', { page: parent, model: state.models[parent].form })
      return;
    }
  }

  if (mode === 'subPages') {
    if(Array.isArray(state.schemes[page].subPages)){
      await Promise.all(state.schemes[page].subPages.map(async (subPage) => {
        await loadMode(
          state, commit, dispatch,
          {
            ..._.cloneDeep(params),
            page: subPage.name,
            mode: subPage.mode,
            subPageOf: page
          });
      }));
    }else{
      if(state.schemes[page].subPages.beforeLoadSubPages){
        await beforeLoadMultiPageMethod(state, commit, params);
      }

      if(state.schemes[page].subPages.asyncLoad || state.schemes[page].subPages.asyncLoad == undefined){
        await Promise.all(state.schemes[page].subPages.pages.map(async (subPage) => {
          await loadMode(
            state, commit, dispatch,
            {
              ..._.cloneDeep(params),
              page: subPage.name,
              mode: subPage.mode,
              subPageOf: page
            });
        }));
      }else{
        for(let i = 0; state.schemes[page].subPages.pages.length > i; i++){
          let subPage = state.schemes[page].subPages.pages[i];
          await loadMode(
            state, commit, dispatch,
            {
              ..._.cloneDeep(params),
              page: subPage.name,
              mode: subPage.mode,
              subPageOf: page
            });
        }
      }
    }

    return;
  }

  await beforeLoadMethod(state, commit, params);

  if (redirectParams) {
    await commit('setPageFilter', { page, redirectParams });
  }

  if (params.mode === 'list') {
    await commit('clearDefaultFilter', params.page);
    const data = Object.values(state.initialSchemes)
      .find(d => d.list && d.list.attributes && d.list.attributes.scrollToBottom)

    if (!!data) {
      setTimeout(() => {
        window.scrollBy({
          top: window.innerHeight,
          behavior: 'smooth'
        });
      }, 1000)
    }
  }

  let newMode = mode || state.schemes[page].default;
  const targetSchemePage = state.schemes[page][newMode];

  if (params.target && params.target === 'page') eventBus.$emit(HANDLERS.BACK_TO_TOP);

  let emptyProcedure = true;

  if ('procedure' in state.schemes[page][newMode]) {
    if (state.schemes[page][newMode].procedure.name != null && state.schemes[page][newMode].procedure.name != undefined && state.schemes[page][newMode].procedure.name != '') emptyProcedure = false;
  }

  if ('steps' in state.schemes[page][mode]) {
    await commit('setModel', { data: {}, page, mode: newMode });
    await commit('setMode', { page, mode: defaultMode || newMode });

    if ((!('procedure' in state.schemes[page][newMode]) || emptyProcedure) && !('component' in state.schemes[page][newMode])) return;
  }

  const listServerSide = (targetSchemePage?.serverSidePaginate && mode === 'list');
  const emptyModel = { [page]: { [newMode]: newMode === 'list' ? [] : {} } };

  const { form, filter, defaultFilter } = getData(state, params);
  if (!listServerSide) {
    showExecuteParams('LoadMode', page, mode, filter, defaultFilter, form);

    const { typeRequest, bodyRequest } = returnNodeDataRequest(
      { schema: state.schemes[page][newMode] },
      { form, filter, defaultFilter, page, isRedirect: true }
    );

    const { data } = await executeServicesData(typeRequest, bodyRequest);

    if (data.invalid) {
      showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });
      return;
    }

    if (data.readOnly) {
      params.hasMaskedField = true;
    }

    model = { [page]: { [newMode]: newMode === 'list' ? data.values : data.values[0] } };
  } else {
    commit('setPageFilter', { page: page + '_paginate', redirectParams: { form, filter, defaultFilter }  });
    model = emptyModel;

    if (params.page === params?.origin || state.schemes[page].subPageOf === state.main) {
      eventBus.$emit(HANDLERS.LOAD_DATA_VALUES_PAGINATE);
    }

    // Quando a paginação é server side o carregamento da lista NÃO é feito no loadMode e sim no loadDataValues
    // dentro de fecthItems do data-table-mixin disparado pelo watch de options assim que a table é montada;
    // porém quando estamos em uma page com i4proTable e navegamos para outra com o mesmo componente, o watch não é disparado uma vez que a table não foi destruída
    // então é necessário forçar o fetchItems para carregar a lista
    if (params.mode === 'list') {
      eventBus.$emit(HANDLERS.LOAD_DATA_VALUES_PAGINATE, {
        resetOptions: true,
        prevPage: params.prevPage
      });
    }
  }

  // É necessário recarregar o filho do modo lista após settar os filtros
  if (params.mode == 'list') {
    eventBus.$emit(HANDLERS.CHILD_RELOAD, params.redirectParams);
  }

  commit('setModel', { data: model[page][newMode], page, mode: newMode });
  if ('master' in state.schemes[page][newMode]) {
    commit('setModel', { data: model[page][newMode], page, newMode, masterContent: true });
    commit('setDefaultFilter', { page, model: model[page][newMode] })
    if ('fields' in state.schemes[page][newMode].master) {
      await initLookups(commit, state, { page, mode: 'master' });
    }
  }

  !params.timerAction && (await commit('setMode', { page, mode: (shouldUsingDefaultMode && defaultMode) ? defaultMode : newMode }));

  if (parent) commit('setParent', { page, parent });
  await dispatch('pageEvents', params);
  dispatch('maskCondition', params);

  // forçando o recarregamento de tabs quando o comando de origem veio de uma page que está dentro de uma tab.
  // É util quando a page é usada tanto fora de uma tab quanto dentro de uma, pois neste caso ela
  // o after dela tem o tab = false e page = true, porem ao emitir esse reset se ela estiver dentro
  // de uma tab, esta será recarregada e poderá definir qual a tab atual pela model ou masterModel com a propridade [default_tab]
  // assim como ocorre na função getEntry (clicar em editar em uma lista)
  if (state.schemes[page][mode]['tabs']) {
    eventBus.$emit(HANDLERS.RESET_TAB, page);
  }

  // se existir um componente de gráfico na página é necessário recarregá-lo para atualizar os dados depois do setModel
  if (document.querySelector('[id*="i4pro-graphic-chartjs"]')) {
    eventBus.$emit(HANDLERS.RELOAD_GRAPHICS);
  }
};

export const loadPage = async (state, commit, dispatch, params, rootState) => {
  let model;
  const { page, parent, redirectParams } = params;

  commit('clearPageFilter', page);

  if (redirectParams) {
    commit('setPageFilter', { page, redirectParams });
  }

  if (params.mode === 'list') {
    commit('clearDefaultFilter', params.page);
  }

  let { data: dataScheme } = await pageServices.getSchema({
    pageName: page,
    moduleName:
      params.module || rootState.module.modulesAllowed.find(x => x.id === rootState.module.defaultModule).folder
  });

  dataScheme = compatibilityMode(dataScheme);

  await store.dispatch('errors/setJsonErrors', dataScheme);

  if (dataScheme.subPages) {
    if(Array.isArray(dataScheme.subPages)){
      await Promise.all(dataScheme.subPages.map(async (subPage) => {
        await loadPage(
          state, commit, dispatch,
          {
            ..._.cloneDeep(params),
            page: subPage.name,
            mode: subPage.mode,
            subPageOf: page
          },
          rootState);
      }));
    }else{
      if(dataScheme.subPages.beforeLoadSubPages){
        await beforeLoadMultiPageMethod(state, commit, params,{ [page]: 'background' in dataScheme ? await setPaths(dataScheme, rootState) : dataScheme });
      }

      if(dataScheme.subPages.asyncLoad || dataScheme.subPages.asyncLoad == undefined){
        await Promise.all(dataScheme.subPages.pages.map(async (subPage) => {
          await loadPage(
            state, commit, dispatch,
            {
              ..._.cloneDeep(params),
              page: subPage.name,
              mode: subPage.mode,
              subPageOf: page
            },
            rootState);
        }));
      }else{
        for(let i = 0; dataScheme.subPages.pages.length > i; i++){
          let subPage = dataScheme.subPages.pages[i];
          await loadPage(
            state, commit, dispatch,
            {
              ..._.cloneDeep(params),
              page: subPage.name,
              mode: subPage.mode,
              subPageOf: page
            },
            rootState);
        }
      }

    }
  }

  await beforeLoadMethod(state, commit, params,{ [page]: 'background' in dataScheme ? await setPaths(dataScheme, rootState) : dataScheme });

  if (params.subPageOf) {
    dataScheme.subPageOf = params.subPageOf;
  }

  const scheme = { [page]: 'background' in dataScheme ? await setPaths(dataScheme, rootState) : dataScheme };
  commit('setInitialScheme', JSON.parse(JSON.stringify(scheme)));

  // if ('master' in scheme[page][params.mode] && redirectParams) {
  //   params.master = JSON.parse(JSON.stringify(params.mode));
  //   params.mode = 'list';
  // }

  scheme[page].default = params.mode;

  if (params.target && params.target === 'page') eventBus.$emit(HANDLERS.BACK_TO_TOP);

  let pageDefault = scheme[page][scheme[page].default];

  let emptyProcedure = true;
  if ('procedure' in pageDefault) {
    if (pageDefault.procedure.name != null && pageDefault.procedure.name != undefined && pageDefault.procedure.name != '') emptyProcedure = false;
  }
  if ('steps' in pageDefault) {

    await commit('setScheme', scheme);
    await commit('setModel', { data: {}, page, mode: scheme[page].default });

    if ((!('procedure' in pageDefault) || emptyProcedure)  && !('component' in pageDefault)) return;
  }

  const listServerSide = (pageDefault?.serverSidePaginate && params.mode === 'list');
  const emptyModel = { [page]: { [scheme[page].default]: scheme[page].default === 'list' ? [] : {} } };

  if (pageDefault.executeInLoad || (scheme[page].default !== 'subPages' && scheme[page].default !== 'list')) {

    const { form, filter, defaultFilter } = getData(state, params);

    // Em telas que não possui lista páginada os dados serão carregados direto neste método
    // Caso contrário, será carregado posteriormente em loadDataValues, contendo todos os filtros
    if (!listServerSide) {
      showExecuteParams('LoadPage', page, params.mode, filter, defaultFilter, form);

      const { typeRequest, bodyRequest } = returnNodeDataRequest(
        { schema: pageDefault },
        { form, filter, defaultFilter, page, isRedirect: true }
      );
      const { data } = await executeServicesData(typeRequest, bodyRequest);

      if (data.invalid) {
        showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });
        return;
      }
      if (data.readOnly) {
        params.hasMaskedField = true;
      }

      model = { [page]: { [scheme[page].default]: scheme[page].default === 'list' ? data.values : data.values[0] } };
    } else {
      commit('setPageFilter', { page: page + '_paginate', redirectParams: { form, filter, defaultFilter }  });
      model = emptyModel;
    }
  } else {
    model = emptyModel;
  }

  commit('setPage', { scheme, model });
  if ('master' in scheme[page][scheme[page].default]) {
    commit('setModel', { data: model[page][scheme[page].default], page, mode: scheme[page].default, masterContent: true });
    commit('setDefaultFilter', { page, model: model[page][scheme[page].default] })
    if ('fields' in state.schemes[page][scheme[page].default].master) {
      await initLookups(commit, state, { page, mode: 'master' });
    }
  }

  if (parent) commit('setParent', { page, parent });
  await dispatch('pageEvents', params);

  dispatch('maskCondition', params);
};

export const beforeLoadMethod = async (state, commit, params, schemaPage) => {

  const schemes = (schemaPage != undefined || schemaPage != null) ? schemaPage :  state.schemes;

  params = checkParams(params, commit);
  const { page, mode, defaultMode, redirectParams, parent } = params;

  const { form, filter, defaultFilter } = getData(state, params);

  let newMode = mode || schemes[page].default;

  //showExecuteParams('BeforeLoad', page, mode, filter, defaultFilter, form);
  //Executando a ação BEFORE [form-btn_proximo2] da page: NXT_EMP_J1_CotacaoDadosSeguro

  if (schemes != undefined ){
    if (schemes[page]!== undefined){
      if (schemes[page][newMode]!== undefined){
        if ('beforeLoad' in  schemes[page][newMode]){

          let pageDefault = schemes[page][newMode];

          const { typeRequest, bodyRequest } = returnNodeDataRequest(
            { schema: pageDefault.beforeLoad },
            { form, filter, defaultFilter, page, isRedirect: true }
          );

          const { data } = await executeServicesData(typeRequest, bodyRequest);

          if (data.invalid) {
            showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });
            return;
          }else{
            console.info('Método: BeforeLoad');
            console.info('Page: ', page);
            console.info('Mode: ', mode);
            console.info('Resultado: ', data);
            console.info('----------------------------------------------------------------------------------------');
            return;
          }

        }
      }
    }
  }
};

export const beforeLoadMultiPageMethod = async (state, commit, params, schemaPage) => {

  const schemes = (schemaPage != undefined || schemaPage != null) ? schemaPage :  state.schemes;

  params = checkParams(params, commit);
  const { page, mode, defaultMode, redirectParams, parent } = params;

  const { form, filter, defaultFilter } = getData(state, params);

  let newMode = mode || schemes[page].default;

  if(schemes != undefined ){
    if(schemes[page]!== undefined){
      if(schemes[page][newMode]!== undefined){
        if('beforeLoadSubPages' in  schemes[page][newMode]){

          let pageDefault = schemes[page][newMode];

          const { typeRequest, bodyRequest } = returnNodeDataRequest(
            { schema: pageDefault.beforeLoadSubPages },
            { form, filter, defaultFilter, page, isRedirect: true }
          );

          const { data } = await executeServicesData(typeRequest, bodyRequest);

          if (data.invalid) {
            showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });
            return;
          }else{
            console.info('Método: BeforeLoadSubPages');
            console.info('Page: ', page);
            console.info('Mode: ', mode);
            console.info('Resultado: ', data);
            console.info('----------------------------------------------------------------------------------------');
            return;
          }

        }
      }
    }
  }
};

export const fillObject = (type, form, filter, defaultFilter, page, InvokeName) => {
  const obj = type;
  delete obj.model;
  obj.model = form;
  obj.filter = filter;
  obj.defaultFilter = defaultFilter;
  obj.page = page;
  obj.InvokeName = InvokeName;

  return obj
}

export const compatibilityMode = scheme => {
  if ('list' in scheme) {
    if (!scheme.list.hasOwnProperty('recordActions')) {
      scheme.list.recordActionsModel = [];
      scheme.list.recordActions = {};
    }

    if (!scheme.list.conditions) {
      scheme.list.conditions = [];
    } else {
      for (const idx in scheme.list.conditions) {
        if ('readonly' in scheme.list.conditions[idx]) {
          continue;
        } else {
          scheme.list.conditions[idx]['readonly'] = {
            fields: []
          };
        }
      }
    }

    if (!scheme.list.inlineConditions) {
      scheme.list.inlineConditions = [];
    } else {
      for (const idx in scheme.list.inlineConditions) {
        if ('readonly' in scheme.list.inlineConditions[idx]) {
          continue;
        } else {
          scheme.list.inlineConditions[idx]['readonly'] = {
            fields: []
          };
        }
      }
    }
  }
  for (let item in scheme) {
    if (item !== 'list' && item !== 'title' && item !== 'breadcrumbs' && item !== 'background' && item !== 'subPages' && item !== 'pages') {
      for (const idx in scheme[item].conditions) {
        if ('readonly' in scheme[item].conditions[idx]) {
          continue;
        } else {
          scheme[item].conditions[idx]['readonly'] = {
            fields: []
          };
        }
      }
    }
  }

  //incluindo id e labelClasses nos items da arvore do schema
  const findAndModify = (json) => {
    if (!!json) {

      if (json['type'] && json['label']) {
        json['labelClasses'] = 'v-label'
      }

      if (json['type'] && json['model'] && !json['id']) {
        json['id'] = json['model']
      }

      // incluir o atributo data-target em itens com atributo de redirect
      if (json['redirect'] && json['redirect']['target'] && json['attributes']) {
        json['attributes']['data-target'] = json['redirect']['target'];
      }

      const keys = Object.keys(json)
      keys.forEach(key => {
        if (typeof json[key] === 'object') {
          if (!Array.isArray(json[key])) {
            json[key] = findAndModify(json[key])
          } else {
            json[key] = json[key].map(item => {
              return findAndModify(item)
            })
          }

        }
      })
      return json
    }
  }

  findAndModify(scheme)


  ///incluindo data-target em actions com redirect



  return scheme;
};

export const loadReportPage = async (state, commit, dispatch, params) => {
  const { data: dataScheme } = await pageServices.getSchemaProcedure({
    name: params.procedure,
    page: params.page,
    invokeName: 'redirect',
    model: params.redirectParams
  });

  const scheme = { [params.page]: dataScheme };

  scheme[params.page].default = params.mode;

  let procedure = {
    name: scheme[params.page][params.mode].procedure.name,
    page: params.page,
    invokeName: 'redirect',
    model: params.redirectParams
  };
  const { data } = await pageServices.executeProcedureAction(procedure);
  const model = { [params.page]: { ['master']: data.values[0] } };

  await commit('setInitialScheme', JSON.parse(JSON.stringify(scheme)));
  await commit('setPage', { scheme, model });
};

export const loadDevPage = async (state, commit, dispatch, params, rootState) => {
  const scheme = { ['dev']: rootState.dev.schema };

  commit('setScheme', scheme);
  commit('setInitialScheme', JSON.parse(JSON.stringify(scheme)));

  let tableModel = [
    {
      name: 'Lorem01',
      calories: 159,
      carbs: 24
    },
    {
      name: 'Lorem02',
      calories: 237,
      carbs: 37
    },
    {
      name: 'Lorem03',
      calories: 262,
      carbs: 23
    }
  ];
  if (scheme['dev'][params.mode].procedure.name.length) {
    if ('master' in scheme['dev'][params.mode]) {
      scheme['dev'][params.mode].procedure.model = state.models['dev']['list'][0];
      const { data } = await pageServices.executeProcedureAction(scheme['dev'][params.mode].procedure);
      if (data.invalid) {
        showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });

        return;
      }

      await commit('setModel', { page: 'dev', data: data.values[0], mode: 'master' });
    } else {
      const { data } = await pageServices.executeProcedureAction(scheme['dev'][params.mode].procedure);
      if (data.invalid) {
        showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });
        return;
      }

      if (data.readOnly) {
        params.hasMaskedField = true;
      }

      let model = '';
      if (params.mode === 'list') {
        model = data.values ? data.values : JSON.parse(JSON.stringify(tableModel));
      } else {
        model = data.values ? data.values[0] : {};
      }

      await commit('setModel', { page: 'dev', data: model, mode: params.mode });
    }
    await dispatch('pageEvents', params);
    dispatch('maskCondition', params);
  } else {
    if ('steps' in scheme['dev'][params.mode] && 'master' in scheme['dev'][params.mode].steps) {
      //debugger carregar dados da master steps
    }
  }
};

export const getData = (state, params) => {
  let form = {};
  let defaultFilter = {};
  let filter = state.pageFilter[params.page] || {}; //adiciona o filtro da page

  //entra aqui quando veio de uma ação
  if (params.systemAction) //
    return { filter, form: {}, defaultFilter: state.defaultFilter[params.parent] || {} };

  if (params.hasOwnProperty('model') && params.hasOwnProperty('defaultFilter'))
    return { filter, form: Array.isArray(params.model) ? {} : params.model, defaultFilter: params.defaultFilter || {} };

  //adiciona o filtro padrão
  if (params.parent)
    defaultFilter = state.defaultFilter[params.parent] || {};
  else if (state.models[params.origin])
    defaultFilter = state.defaultFilter[params.origin] || {};
  else if (params.mode === 'search' && params.defaultMode === 'list') {
    parent = state.parents[params.page];
    defaultFilter = state.defaultFilter[parent] || {};
  }


  if (params.lineModel)
    form = { ...form, ...params.lineModel };

  if (params.componentModel)
    form = { ...form, ...params.componentModel };

  return { form, filter, defaultFilter };
};

export const getModels = (state, params) => {
  let twoModels = false;
  let defaultFilter = new Object();
  let originalMode;
  let models = Decrypt(sessionStorage.getItem('data'), 'i4pro');
  let model = params.model ? params.model : state.models[params.page][params.master ? 'master' : params.mode];
  const filterInitialModel = params.action?.filterData?.initialModel;
  const filterModel  = params.action?.filterData?.model;
  const filterTable = (store.getters['page/pageFilter'](params.page) || {});

  let initialModel =
    params.mode == 'list' && 'index' in params
      ? models[params.page][params.mode][params.index]
      : models[params.page][params.mode];

  if (params.child && params.action.useParentModel) {
    twoModels = true;
    originalMode = params.mode;
    params.mode = 'list';
    initialModel =
      'index' in params ? models[params.page][params.mode][params.index] : models[params.page][params.mode];
  }

  if (params.master && model) {
    params.mode = 'master';
    model['currentTab'] = state.currentTabs[params.page];
  }

  if ((params.mode === 'list' && !('index' in params)) || ((params.mode === 'new' || params.mode === 'form') && 'customModelArray' in state.initialSchemes[params.page][params.mode].attributes)) {
    const result = getSelectedItems(state, params.page, params.mode, model, initialModel);
    model = result.model;
    initialModel = result.initialModel;

  }

  defaultFilter = params.tab ? state.defaultFilter[params.page] : state.defaultFilter[state.parents[params.page]];

  if (filterInitialModel) {
    initialModel = filterDataAccordingPageMode(
      {
        mode: params.mode,
        filters: filterInitialModel,
        currentData: initialModel
      }
    );
  }
  if (filterModel) {
    model = filterDataAccordingPageMode(
      {
        mode: params.mode,
        filters: filterModel,
        currentData: model
      }
    );
  }

  return {
    twoModels,
    originalMode,
    model: 'systemAction' in params.action ? {} : model,
    initialModel,
    defaultFilter,
    filterTable
  };
};

export const redirect = async (state, params, model, defaultFilter) => {
  const { page, mode, target, entry, dialog } = params.action.redirect;

  let routeParams = {
    page,
    mode,
    dialog,
    defaultMode: mode,
    origin: params.page,
    line: params.index,
    lineModel: params.model,
    componentModel: params.componentModel,
    module: 'module' in params.action.redirect ? params.action.redirect.module : null,
    timerAction: params.timerAction,
    model,
    defaultFilter,
    systemAction: params.action.systemAction
  };


  if (params.mode === 'list' && target === 'dialog' && model.length != undefined) routeParams.model = state.defaultFilter[(state.main)];
  if (entry) routeParams.redirectParams = formatEntry(entry);
  if (params.origin === 'dialog') eventBus.$emit(HANDLERS.CLOSE_DIALOG, page);
  if (params.origin === 'down') eventBus.$emit(HANDLERS.CLOSE_FORM_BELOW);

  // Caso algum redirect seja feito para um outro arquivo JSON/ page.
  //  Atribui novas passagens de filtros
  if (routeParams.origin !== page) {
    if (params.mode === 'list') {
      // Ação foi instânciada por actionInLine?
      //   Se não, passa a diante o context necessários que foi carregada na model da lista
      if (routeParams.lineModel && Object.entries(routeParams.lineModel).length) {
        routeParams.redirectParams = params.model
      } else {
        routeParams.redirectParams = model[0] ?? {}
      }
    } else {
      routeParams.redirectParams = model;
    }
  }

  routeParams.target = target;
  routeParams.parent = state.parents[page];

  if (target && target !== 'page') {
    routeParams.defaultMode = state.schemes[params.page].default;
    await loadRoute(routeParams);

    //if (target === 'sidebar') return;
    eventBus.$emit(params.mode === 'list' ? HANDLERS.RENDER_COMPONENT_IN_LIST : HANDLERS.RENDER_COMPONENT_IN_FORM, {
      context: mode,
      page,
      showIn: target,
      origin: params.page,
      dialog
    });

    return;
  }

  await loadRoute(routeParams);
};

export const getSelectedItems = (state, page, mode, model, initialModel) => {
  if (state.schemes[page]['list'].attributes.attributesTable.dataTable?.preserveModel) return { model, initialModel };

  let newModel = JSON.parse(JSON.stringify(model));
  let newInitialModel = JSON.parse(JSON.stringify(initialModel));

  if (state.schemes[page]['list']) {
    if ('attributesTable' in state.schemes[page]['list'].attributes) {
      if (state.schemes[page]['list'].attributes.attributesTable.dataTable.showSelect) {
        newModel = state.selectedItems.items;

        const selectedInitialItems = initialModel.filter(item =>
          state.selectedItems.items.find(x => {
            if (x[state.selectedItems.keyValue] === item[state.selectedItems.keyValue]) return item;
          })
        );
        newInitialModel = selectedInitialItems;
      }
    }
  }

  if ('customModelArray' in state.initialSchemes[page][mode].attributes) {
    let newModelDynamic = [];
    for (let i = 0; i < state.selectedItems.items.length; i++) {
      let tempModel = { ...model, ...state.selectedItems.items[i] }
      newModelDynamic.push(tempModel);
    }

    return { model: newModelDynamic, initialModel: newModelDynamic };
  }

  return { model: newModel, initialModel: newInitialModel };
};

export const afterEvents = async (state, commit, dispatch, params, data, requestParams) => {
  const { update, page, tab, step, parameters, updateMaster } = params.action.after;
  const dictionaryReturnsEntry = data.dictionaryReturns['@entry'] ?? null;
  let redirectParams = {};

  const hasParameters = parameters && Object.keys(parameters).length > 0

  // resetDefaultFilter limpa todo o defaultFilter
  if ((hasParameters && parameters.resetDefaultFilter) || data.dictionaryReturns['@resetDefaultFilter']) {
    store.commit('page/resetDefaultFilter')
  }

  // cleanDefaultFilter irá limpar o defaultFilter das páginas informadas no array
  if ((hasParameters && parameters.cleanDefaultFilter) || data.dictionaryReturns['@cleanDefaultFilter']) {
    const cleanDefaultFilter = parameters?.cleanDefaultFilter || data.dictionaryReturns['@cleanDefaultFilter']
    const destinationPage = parameters?.page || data.dictionaryReturns['@page']
    const pagesToClear = setPagesToClearDefaultFilter(cleanDefaultFilter, destinationPage)
    pagesToClear.forEach(p => {
      store.commit('page/clearDefaultFilter', p)
    })
  }

  // resetPageFilter limpa todo o pageFilter
  if ((hasParameters && parameters.resetPageFilter) || data.dictionaryReturns['@resetPageFilter']) {
    store.commit('page/resetPageFilter')
  }

  // cleanPageFilter irá limpar apenas o pageFilter da página destino do redirect
  if ((hasParameters && parameters.cleanPageFilter) || data.dictionaryReturns['@cleanPageFilter']) {
    commit('clearPageFilter', page);
  }

  // cleanModel irá resetar tudo: defaultFilter, pageFilter, model, schemes
  if ((hasParameters && parameters.cleanModel) || data.dictionaryReturns['@cleanModel']) {
    store.commit('page/clear', { state })
    await eventBus.$emit(HANDLERS.ENABLE_FOOTER);
  }

  // Após as limpezas, se houver um redirect para uma página, ele será executado normalmente no loadRoute ao final do método

  //exemplo = "cd_apolice=123456;id_endosso=1;id_apolice=10; nm_segurado= 'Bozo'";
  if (dictionaryReturnsEntry || hasParameters) {
    redirectParams = dictionaryReturnsEntry
      ? formatEntry(dictionaryReturnsEntry)
      : formatEntryFromEntryFields(parameters.entryFields, data, params.action.index);
  }

  if (updateMaster) {
    const masterPage = state.parents[params.page] ? state.parents[params.page] : params.page;
    const mode = state.schemes[masterPage].default;

    if ('master' in state.schemes[masterPage][mode]) {
      const { typeRequest, bodyRequest } = returnNodeDataRequest(
        { schema: state.schemes[masterPage][mode] },
        { form: state.defaultFilter[masterPage], page, isRedirect: true }
      );

      const { data: masterData } = await executeServicesData(typeRequest, bodyRequest);

      if (masterData.invalid) {
        showMessage(commit, { message: masterData.dictionaryReturns['@ds_retorno'] });
        return;
      }

      await commit('setModel', { page: masterPage, data: masterData.values[0], mode, masterContent: true });

      if ('fields' in state.schemes[masterPage][mode].master)
        await initLookups(commit, state, { page: masterPage, mode: 'master' });

      if (!tab) eventBus.$emit('RELOAD_TAB', params.origin);
    }
  }

  if (params.master) eventBus.$emit('RELOAD_TAB', params.origin);

  if (update) {
    const targetMode = params.child ? state.schemes[params.page].default : params.mode;

    // Após executar ações de itens da lista e seja necessário atualizar a model
    //  É preciso executar a procedure/component do MODO da PAGE para puxar os novos valores e atualizar a MODEL
    if (!Array.isArray(data.values) && !(typeof data.values !== 'object' && data.values === null) && targetMode === 'list') {

      const requestParamsUpdate = {
        form: {},
        filter: JSON.parse(JSON.stringify(state.pageFilter[params.page])),
        defaultFilter: {},
        page: params.page,
        isRedirect: false,
        InvokeName: 'Ação After:Update'
      };

      const { typeRequest, bodyRequest } = returnNodeDataRequest(
        { schema: state.schemes[params.page][params.mode] },
        requestParamsUpdate
      );

      if (!typeRequest) return;
      const { data: dataToUpdateModel } = await executeServicesData(typeRequest, bodyRequest);

      await commit('updateModel', {
        page: params.page,
        mode: targetMode,
        model: dataToUpdateModel.values
      });

      return;
    };

    await commit('updateModel', {
      page: params.page,
      mode: targetMode,
      model: targetMode == 'list' ? data.values : data.values[0]
    });

    if (targetMode !== 'list') {
      await initLookups(commit, state, { mode: targetMode, page: params.page, tab: params.tab, step: params.step });
      await dispatch('conditions', { page: params.page, mode: targetMode, tab: params.tab, step: params.step });
    }

    if (
      params.child &&
      data.values.length === 1 &&
      targetMode == 'list' &&
      state.schemes[params.page].list.child.setAutomatically
    ) {
      eventBus.$emit('RECEIVE_ENTRY', { page: params.page, entry: data.values[0] });
    }

    if (params.child) {
      commit('setPageFilter', { page: params.page, redirectParams: structuredClone(requestParams.model) });
    }
  }

  if (tab && (data.dictionaryReturns['@tab'] || parameters.tab)) {
    !parameters.keepDialog && eventBus.$emit(HANDLERS.CLOSE_DIALOG, params.page);
    !parameters.keepSidebar && eventBus.$emit(HANDLERS.CLOSE_DRAWER_DINAMIC);

    if (parameters?.cleanPageFilter) {
      let { page: pageToCleanFilter, mode: modeToCleanFilter } = state.schemes[state.parents[params.page]].form.tabs.content[data.dictionaryReturns['@tab'] || parameters.tab].page;

      executeRecursiveCallbackInsideMultipage(
        state,
        {
          page: pageToCleanFilter,
          mode: modeToCleanFilter,
          callback: ({ page, mode }) => {
            if (mode === 'list') {
              commit('clearPageFilter', page);
              eventBus.$emit(HANDLERS.CHILD_RELOAD, redirectParams);
            }
          }
        }
      );
    };

    eventBus.$emit('CHANGE_TAB', {
      tab: data.dictionaryReturns['@tab'] || parameters.tab,
      page: params.page,
      parentPage: state.parents[params.page],
      mode: params.mode
    });
    return;
  }

  if (step) {
    if (dictionaryReturnsEntry || (parameters.entryFields && data.values.length)) {
      await commit('setDefaultFilter', {
        page: params.page,
        model: redirectParams
      });

      if (state.parents[params.page] != undefined) {
        commit('setPageFilter', { page: state.parents[params.page], redirectParams });
        let parentMode = state.schemes[state.parents[params.page]].default;
        await commit('updateModel', {
          page: state.parents[params.page],
          mode: parentMode,
          model: parentMode == 'list' ? data.values : data.values[0]
        });
      }
    }

    // Verificar
    const filter = Object.values(state.defaultFilter)

    if (!filter[0] && params.step != data.dictionaryReturns['@step']) {
      showMessage(commit, {
        message: 'Um contexto de navegação entre steps não foi definido no retorno da ação',
        color: 'error'
      });

    }

    eventBus.$emit('CHANGE_STEP', { step: data.dictionaryReturns['@step'] || parameters.step });
  }

  if (page && (data.dictionaryReturns['@page'] || parameters.page)) {
    if (params.origin === 'down') eventBus.$emit(HANDLERS.CLOSE_FORM_BELOW);
    !parameters.keepDialog && eventBus.$emit(HANDLERS.CLOSE_DIALOG, params.page);
    !parameters.keepSidebar && eventBus.$emit(HANDLERS.CLOSE_DRAWER_DINAMIC);

    if (!(Array.isArray(data.values)) && data.values !== null && data.values !== undefined && params.componentModel) {
      data.values = params.componentModel;
    }

    // Após atualizar data.values é necessário atualizar o redirectParams novamente
    //  exemplo = "cd_apolice=123456;id_endosso=1;id_apolice=10; nm_segurado= 'Bozo'";
    if (dictionaryReturnsEntry || hasParameters) {
      redirectParams = dictionaryReturnsEntry
        ? formatEntry(dictionaryReturnsEntry)
        : formatEntryFromEntryFields(parameters.entryFields, data, params.action.index);
    }

    let routeParams = {
      page: data.dictionaryReturns['@page'] || parameters.page,
      mode: data.dictionaryReturns['@mode'] || parameters.mode,
      origin: params.page,

    };

    if (parameters?.cleanPageFilter && ['list', 'subPages'].includes(routeParams.mode)) {
      executeRecursiveCallbackInsideMultipage(
        state,
        {
          page: routeParams.page,
          mode: routeParams.mode,
          callback: ({ page, mode }) => {
            if (mode === 'list') {
              commit('clearPageFilter', page);
              eventBus.$emit(HANDLERS.CHILD_RELOAD, redirectParams);
            }
          }
        }
      );
    };

    if (state.schemes[routeParams?.page]?.list?.cleanFiltersAfterReturn) {
      commit('cleanFiltersAfterReturn', routeParams?.page)
      if (redirectParams.hasOwnProperty('ds_filtro')) {
        redirectParams.ds_filtro = {}
      };
    };

    // Carrega redirect na mesma page
    if (parameters.target === 'below') {
      routeParams.dialog = parameters.dialog;
      routeParams.defaultMode = state.schemes[params.page].default;
      routeParams.line = params.index;
      routeParams.lineModel = params.model;
      routeParams.componentModel = params.componentModel;
      routeParams.timerAction = params.timerAction;
      routeParams.model = requestParams.model;
      routeParams.systemAction = params.action.systemAction;
      routeParams.target = parameters.target;
      routeParams.parent = state.parents[params.page];

      await loadRoute(routeParams);

    } else {
      routeParams.parent = state.parents[parameters.page],
      routeParams.redirectParams = Object.entries(redirectParams).length ? redirectParams : undefined,
      routeParams.target = parameters.target && parameters.target === 'dialog' ? 'dialog' : data.dictionaryReturns['@page'] ? 'page' : params.origin === 'dialog' ? 'dialog' : 'page',

      routeParams.rootLevel = parameters.rootLevel

      await loadRoute(routeParams);
    }


    if (parameters.target && (parameters.target === 'dialog' || parameters.target === 'below')) {
      eventBus.$emit(params.mode === 'list' ? HANDLERS.RENDER_COMPONENT_IN_LIST : HANDLERS.RENDER_COMPONENT_IN_FORM, {
        context: parameters.mode,
        page: parameters.page,
        showIn: parameters.target,
        origin: params.page,
        dialog: parameters.dialog
      });
    }
  }
};

export const downloadECM = async (action, model) => {
  const domain = model.id_dominio ? model.id_dominio : action.ecm.domain;
  const id_tp_document = model.id_tp_documento ? model.id_tp_documento : action.ecm.id_tp_document;
  const { modelDocumentId } = action.ecm;

  const { data: key } = await ECM.GetKey(domain);

  if (modelDocumentId) {
    let hash = `${model[modelDocumentId].toString().padStart(9, '0')}${model[key]}`;

    const { data: document } = await ECM.DownloadDocument(hash);

    if (document)
      downloadFile(
        document.content,
        document.contentType,
        document.fileName.split('.').pop(),
        document.fileName.split('.').shift()
      );
  } else {
    const { data: documents } = await ECM.GetDocuments(domain, id_tp_document, model[key]);
    let hashs = documents.map(item => {
      let hash = item.id.toString().padStart(9, '0');
      return `${hash}${item.keyValues}`;
    });

    const { data: file } = await ECM.DownloadDocuments(hashs);

    if (file)
      downloadFile(file.content, file.contentType, file.fileName.split('.').pop(), file.fileName.split('.').shift());
  }
};

export const uploadEcm = async (state, params, rootState, mainMode, commit) => {
  const mode = mainMode ? mainMode : params.master ? 'master' : params.mode;
  let schema;

  if (params.tab && state.schemes[params.page][mode].tabs && !('page' in state.schemes[params.page][mode].tabs.content[params.tab])) {
    schema = state.schemes[params.page][mode].tabs.content[params.tab];
  } else {
    schema = state.schemes[params.page][mode];
  }

  const fieldsGroups = schema.groups.reduce(
    (result, item) => (result = [...result, ...item.fields.map(field => field)]),
    []
  );
  const fields = [...schema.fields, ...fieldsGroups].filter(x => x.ecm);
  const ecmReturn = mainMode ? {} : [];

  if (fields.length) {
    if (!mainMode) {
      const promises = fields.map(async field => {
        const { data: ecmkey } = await ECM.GetKey(field.ecm.domain ? field.ecm.domain : state.models[params.page][params.mode].id_dominio);

        if (
          state.models[params.page][mode][field.model] &&
          state.models[params.page][mode][field.model] instanceof File
        ) {
          let document = {
            id_tp_document: field.ecm.id_tp_document ? field.ecm.id_tp_document : state.models[params.page][params.mode].id_tp_documento,
            files: [state.models[params.page][mode][field.model]],
            dt_document: new Date()
          };
          const response = await ECM.InsertDocument(
            document,
            field.ecm.domain ? field.ecm.domain : state.models[params.page][params.mode].id_dominio,
            state.models[params.page][mode][ecmkey]
          );

          if (response === undefined || response.status === 413) {
            showMessage(commit, {
              message: 'Tamanho de arquivo excedeu o limite permitido.',
              color: 'error'
            });
            ecmReturn.push(undefined);
            return
          }

          if (response.status === 200) {
            ecmReturn.push({
              filename: state.models[params.page][mode][field.model].name,
              model: field.model,
              value: response.data,
              keyValue: state.models[params.page][mode][ecmkey]
            });
          }
        }
      });

      await Promise.all(promises);
    } else {
      const promises = fields.map(async field => {
        let items =
          'attributesTable' in state.schemes[params.page]['list'].attributes &&
            state.schemes[params.page]['list'].attributes.attributesTable.dataTable.showSelect
            ? state.selectedItems.items
            : state.models[params.page]['list'];

        const { data: ecmkey } = await ECM.GetKey(field.ecm.domain ? field.ecm.domain : state.models[params.page][params.mode].id_dominio);

        const promisses = items.map(async (model, idx) => {
          if ('fileSend' in field.ecm && field.ecm.fileSend in model && model[field.ecm.fileSend] == 1) {
            showMessage(commit, {
              message: 'Arquivo já foi enviado, para o item selecionado ',
              color: 'error'
            });
          } else if (
            state.models[params.page][mode][field.model] &&
            state.models[params.page][mode][field.model] instanceof File
          ) {
            let document = {
              id_tp_document: field.ecm.id_tp_document ? field.ecm.id_tp_document : state.models[params.page][params.mode].id_tp_documento,
              files: [state.models[params.page][mode][field.model]],
              dt_document: new Date()
            };
            const response = await ECM.InsertDocument(document, field.ecm.domain ? field.ecm.domain : state.models[params.page][params.mode].id_dominio, model[ecmkey]);
            if (response.status === 200) {
              ecmReturn[idx] = {
                filename: state.models[params.page][mode][field.model].name,
                model: field.model,
                value: response.data,
                keyValue: model[ecmkey]
              };
            }
          }
        });

        await Promise.all(promisses);

        state.models[params.page][mode][field.model] = null;
      });

      await Promise.all(promises);
    }
  }
  return ecmReturn;
};

export const generatePdfReport = async (action, model, commit) => {
  const { reportId, fileName } = action.report;
  const { data } = await reportServices.generateReport({ model, reportId, typeReport: reports.PDF });

  if (data) {
    downloadFile(data, 'application/pdf', 'pdf', fileName);

    showMessage(commit, {
      message: "Processamento efetuado com sucesso",
      color: "green"
    });
  }
};

export const generateTxtReport = async (action, model) => {
  const { reportId } = action.txt;
  const { data } = await reportServices.generateReport({ model, reportId, typeReport: reports.EXCEL });
  if (data[0].length)
    saveAs(
      new Blob(
        data[0].map(line => `${line[Object.keys(line)[0]]}\r\n`),
        { type: 'text/plain;charset=utf-8' }
      ),
      `${Date.now()}.txt`
    );
  else showMessage(commit, { message: 'Sem resultado' });
};

export const generateExcelReport = async (action, model, commit, page='') => {
  const { reportId } = action.excel;
  const { typeRequest, bodyRequest } = returnNodeDataRequest(
    { schema: action.excel },
    { form: model, filter: {}, defaultFilter: {}, page, isRedirect: false }
  );
  const containRequest = (!reportId && typeRequest);

  if (containRequest) {
    const { data } = await executeServicesData(typeRequest, bodyRequest);

    if (data.invalid) {
      showMessage(commit, { message: data.dictionaryReturns['@ds_retorno'] });
      return;
    };

    const message = getMessageClass(data);
    showMessage(commit, {
      message: data.dictionaryReturns['@ds_retorno'],
      color: data.dictionaryReturns['@message_class'] || message,
      sweetAlert: message !== 'success' ? true : false
    });

    downloadExcelFilledByDataAPI({ headersToExcel: action.excel?.headers, data: data.values, page, fileName: action.excel?.fileName });

    return;
  }

  const { data } = await reportServices.generateReport({ model, reportId, typeReport: reports.EXCEL });

  if (data) {
    downloadExcel(data.filter(x => x.length ));

    showMessage(commit, {
      message: "Processamento efetuado com sucesso",
      color: "green"
    });
  }

};

export const downloadExcel = data => {
  let hasTabs = false;
  let formated = [];
  let workbook = XLSX.utils.book_new();

  data.forEach(item => {
    if ('nr_tab' in item[0]) {
      hasTabs = true;
    }
  });

  if (hasTabs) {
    data.forEach(element => {
      const fields = [];
      element.forEach(line => {
        const { nr_tab, ...rest } = line;
        fields.push(rest);
      });

      const index = formated.findIndex(x => x.tab === element[0].nr_tab);

      if (index !== -1) formated[index].fields = [...formated[index].fields, [], ...fields];
      else formated.push({ tab: element[0].nr_tab, fields });
    });

    formated.forEach(element => {
      workbook.SheetNames.push(`Sheet${element.tab}`);
      workbook.Sheets[`Sheet${element.tab}`] = XLSX.utils.aoa_to_sheet(formatExcel(element.fields));
    });
  } else {
    workbook.SheetNames.push('Sheet1');
    data.forEach(element => formated.push(formatExcel(element)));
    workbook.Sheets['Sheet1'] = XLSX.utils.aoa_to_sheet([].concat(...formated));
  }

  XLSX.writeFile(workbook, `${Date.now()}.xlsx`);
};

export const downloadExcelFilledByDataAPI = ({ headersToExcel, data, page, fileName }) => {
  if (!data || !data.length) { return }

  let formatedModel = [];
  let workbook = XLSX.utils.book_new();
  let headers = headersToExcel ?? [];

  if (!headers || !headers.length) {
    Object.keys(data[0]).forEach( prop => {
      headers.push({ 'desc': prop, 'value': prop });
    });
  }

  for (let item of data) {
    let newItem = {};
    for (let header of headers) {
      newItem[header.desc] = item[header.value];
    }
    formatedModel.push(newItem);
  }

  const fileNameToExported = `${fileName}.xlsx` ?? `${page.charAt(0).toUpperCase() + page.slice(1)}-${Date.now()}.xlsx`;
  XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(formatedModel));
  XLSX.writeFile(workbook, fileNameToExported);

  return fileNameToExported;
};

export const formatExcel = items => {
  const formated = [];
  let last = {};

  items.forEach(element => {
    if (!Object.keys(element).every(prop => last.hasOwnProperty(prop))) {
      formated.push(Object.keys(element));
    }

    formated.push(Object.values(element));
    last = element;
  });

  formated.push([]);

  return formated;
};

export const sleep = async ms => {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
};

export const getExecuteMode = params => {
  if ('runOnce' in params.action.params && params.action.params.runOnce) return 'form';

  if (params.mode !== 'list' || 'index' in params) return 'form';
  else return 'list';
};

export const getMessageClass = data => {
  if (data.dictionaryReturns['@id_retorno'] > 0) return 'error';
  if (data.dictionaryReturns['@id_retorno'] < 0) return 'warning';
  return 'success';
};

export const removeActionsMaster = list => {
  list.forEach((item, index) => {
    if (item.label == 'Anterior' || item.label == 'Próximo') {
      list.splice(index, 1);
    }
  });
};

export const addActionsMaster = (list, page, mode) => {
  let actionsVisible = false;
  list.forEach((item, index) => {
    if (item.label == 'Anterior' || item.label == 'Próximo') {
      actionsVisible = true;
    }
  });

  if (!actionsVisible) {
    list.push({
      attributes: {
        color: 'primary'
      },
      attributesIcon: {
        icon: 'fas fa-arrow-circle-left'
      },
      label: 'Anterior',
      navigation: 'previous',
      page,
      mode,
      visible: true
    });

    list.push({
      attributes: {
        color: 'primary'
      },
      attributesIcon: {
        icon: 'fas fa-arrow-circle-right'
      },
      label: 'Próximo',
      navigation: 'next',
      page,
      mode,
      visible: true
    });
  }
};

export const showExecuteParams = (method, page, mode, filter, defaultFilter, model) => {
  console.info('Método: ', method);
  console.info('Page: ', page);
  console.info('Mode: ', mode);
  console.info('Filtro da Tela: ', Object.entries(filter).length ? filter : 'no data');
  console.info('Filtro Padrão: ', Object.entries(defaultFilter).length ? defaultFilter : 'no data');

  if (model) {
    console.info('Model: ', Object.entries(model).length ? model : 'no data');
  }

  console.info('----------------------------------------------------------------------------------------');
}

export const getAcceptsFiles = (state, page, mode, tab, step, model) => {
  let fields = {};

  if (state.schemes[page][mode].tabs) {
    // somente fields dentro de tab e dentro de grupo de coluna
    state.schemes[page][mode].tabs.content[tab].groups.forEach(group => {
      group.fields.forEach(field => {
        if (field.model === model) {
          fields[model] = field.attributesTextField.accept;
        }
      });
    });
    // somente fields dentro de tab
    state.schemes[page][mode].tabs.content[tab].fields.forEach(field => {
      if (field.model === model) {
        fields[model] = field.attributesTextField.accept;
      }
    });
  }
  if (state.schemes[page][mode].steps) {
    // somente fields dentro de steps e dentro de grupo de coluna
    state.schemes[page][mode].steps.content[step].groups.forEach(group => {
      group.fields.forEach(field => {
        if (field.model === model) {
          fields[model] = field.attributesTextField.accept;
        }
      });
    });
    // somente fields dentro de steps
    state.schemes[page][mode].steps.content[step].fields.forEach(field => {
      if (field.model === model) {
        fields[model] = field.attributesTextField.accept;
      }
    });
  }
  // somente fields dentro de groups
  state.schemes[page][mode].groups.forEach(group => {
    group.fields.forEach(field => {
      if (field.model === model) {
        fields[model] = field.attributesTextField.accept;
      }
    });
  });
  // somente fields
  state.schemes[page][mode].fields.forEach(field => {
    if (field.model === model) {
      fields[model] = field.attributesTextField.accept;
    }
  });
  return fields;
}

export const executeLoopActionInMultipages = async ({ getters, dispatch }, params, adapter, action) => {
  // filtrar as paginas irmãs, ou seja todas as sub-paginas menos a atual
  const siblingsPages = getters.siblingsSubPages(params.page);
  let continueExecution;

  // Percorre a lista de actions da page e executa a action
  for(const siblingsPage of siblingsPages) {
    const actions = getters.actions_scheme({ page: siblingsPage.name, mode: siblingsPage.mode });

    // recuperar a page action da sub page
    const pageAction = actions?.items?.find(m => m.pageAction) || false;

    if(!pageAction) continue;

    if (action === 'actionBefore' && !pageAction.before) {
      console.info(`NÃO FOi REFERÊNCIADA a action [${action}] da action [${pageAction.actionName}] da page: [${siblingsPage.name}]`);
      continue
    }

    // Executa o dispatch da action
    continueExecution = executeNodeAction({dispatch}, params, adapter({params, siblingsPage, pageAction}), action);
    if (continueExecution === false)
      return
  }

  // Executa a action before da action[executePageActions]
  if (action === 'actionBefore' && params.action.before) {
    console.info(`Executando a ação BEFORE da action [${params.action.actionName}] da page master: ${params.page}`);

    continueExecution = executeNodeAction(
      {dispatch},
      params,
      { action: params.action, master: params.master, model: params.componentModel },
      action
    );

    if (continueExecution === false)
      return
  }

  // Retorna o estado para progressão do fluxo
  return continueExecution;
}

const executeNodeAction = async ({ dispatch }, params, adapter, action) => {
  const message = {
    'actionBefore': 'BEFORE',
    'executeAction': 'PRINCIPAL',
  }
  const contunueExecution = await dispatch(action, adapter);

  if (contunueExecution === false) {
    console.info(`Interrompendo a execução devido id_retorno <> 0 da action ${message[action]}: [${adapter.action.actionName}] da page: [${adapter.page}]`)
  }
  return contunueExecution;
}

// beforeActionAdapter e mainActionAdapter são funções adaptaveis para retornar os parametros necessários para o dispacth da action
export const beforeActionAdapter = ({params, siblingsPage, pageAction}) => {
  return {
    ...params,
    page: siblingsPage.name,
    mode: siblingsPage.mode,
    action: pageAction
  }
}

export const mainActionAdapter = ({params, siblingsPage, pageAction}) => {
  return {
    ...params,
    page: siblingsPage.name,
    mode: siblingsPage.mode,
    action: pageAction,
  }
}

export const compileDynamicString = ({ page, mode, originalString, index }) => {

  const compiledParams = parseValueModel({ page, mode, originalString });

  if (_.isEqual({ page, mode, originalString }, compiledParams))
    return originalString;

  return getValueFromModel(
    { state: store.state.page },
    compiledParams,
    originalString,
    index
  );
};

export const parseValueModel = ({ page, mode, originalString }) => {
  // {folder/page.mode.key_model}
  let patternModelDifferentPage = /^(\{([a-zA-Z0-9_\-\/]+\/)?([a-zA-Z0-9_\-]+)\.([a-zA-Z0-9_\-]+)\.([a-zA-Z0-9_\-]+)\})$/;

  // {key_model}
  let patternModelSamePage = /^(\{[\w\-]+\})$/;

  // {folder/page.key_model}
  let patternModelDifferentPageWithDefaultMode = /^(\{([\w\-\/]+\/)?([\w\-]+)\.([\w\-]+)\})$/;

  if (
    !patternModelDifferentPage.test(originalString) &&
    !patternModelSamePage.test(originalString) &&
    !patternModelDifferentPageWithDefaultMode.test(originalString)
  ) return { page, mode, originalString };

  let keyModel;

  // Remove as chaves da string
  const stringToBeCompiler = originalString.substring(1, (originalString.length - 1));

  if (patternModelDifferentPage.test(originalString) || patternModelDifferentPageWithDefaultMode.test(originalString)) {
    // Formato de entrada: "page.mode.key_model" e "page.key_model"
    page = stringToBeCompiler.split('.').shift();
    keyModel = stringToBeCompiler.split('.').pop();

    // Caso não tenha modo especificado, é colocado um parâmetro personalizado
      // para ser preenchido posteriormente com o DEFAULT MODE da PAGE
    mode = patternModelDifferentPage.test(originalString)
      ? stringToBeCompiler.split('.')[1]
      : '__selectDefaultMode';

  } else if (patternModelSamePage.test(originalString)) {
    // Formato de entrada: "key_model"
    keyModel = stringToBeCompiler;
  }

  return ({ page, mode, keyModel });
};

export const getValueFromModel = ({ state },{ page, mode, keyModel }, originalString, index) => {
  try{
    if (mode === '__selectDefaultMode') {
      mode = state.schemes[page].default;
    }

    let valueModel = mode === 'list' ? state.models[page][mode][index ?? 0][keyModel] : state.models[page][mode][keyModel];

    return (valueModel || valueModel === null) ? valueModel : originalString
  } catch(err) {
    console.error(err);
    return originalString;
  };
};

export const returnNodeDataRequest = ( { schema }, { form, filter, defaultFilter, page=false, isRedirect=true, InvokeName=null }) => {
  const types = ['procedure', 'component', 'requestApi','initialData'];
  const typeRequest = types.find( type => type in schema );
  if (!typeRequest) {
    console.error('Não foi definido corretamente uma estrutura de requisição correta!');
    return false;
  };


  let bodyRequest = {};
  if (typeRequest === 'initialData')
    bodyRequest.initialData = structuredClone( schema[typeRequest] || {} );
  else
    bodyRequest = structuredClone( schema[typeRequest] || {} )

  delete bodyRequest.model;
  form && (bodyRequest.model = form);
  filter && (bodyRequest.filter = filter);
  defaultFilter && (bodyRequest.defaultFilter = defaultFilter);
  isRedirect && (bodyRequest.InvokeName = 'redirect');
  InvokeName && (bodyRequest.InvokeName = InvokeName);
  bodyRequest.page = page;

  return { typeRequest, bodyRequest };
};

export const executeServicesData = async (typeRequest, body, execInList=false) => {
  switch(typeRequest) {
    case 'procedure':
      return !execInList
        ? await pageServices.executeProcedureAction(body)
        : await pageServices.executeProcedureActionList(body);
    case 'component':
      return !execInList
        ? await pageServices.executeComponentAction(body)
        : await pageServices.executeComponentActionList(body);
    case 'requestApi':
      return await pageServices.executeRequestApiAction(body);
    case 'initialData':
      return executeInitialData(body);
    default:
      console.error('Não foi especificado o tipo de requisição para recuperar o dado desejado');
      return null;
  }
};

export const executeInitialData = (body) => {
  const { initialData, filter, defaultFilter, model } = body;
  let values = [];

  // Verifica se os dados iniciais pertence a uma lista
  if (Array.isArray(initialData)) {
    values = initialData;
  } else {
    if (initialData.hasOwnProperty('__notMergeFilters') && initialData?.__notMergeFilters) {
      values.push(Object.assign(initialData, model));
    } else {
      values.push(Object.assign(initialData, model, filter, defaultFilter));
    }
  }

  let data = {
    "values": values,
    "dictionaryBusiness": {},
    "dictionaryReturns": {
      "@id_retorno": 0,
      "@ds_retorno": ""
    },
    "dictionaryExecParameters": {},
    "readOnly": false,
    "errorResponse": "",
    "listSchemaColumns": [],
    "notifications": [],
    "isValid": true
  };

  return { data }
};

export const executeRecursiveCallbackInsideMultipage = (state, { page, mode, callback=() => {} }) => {
  if (!page || !mode || !state) return;

  if (mode === 'subPages') {
    let subPages = store.getters['page/subPages'](page);
    if (!subPages) {
      console.error(`Não foi encontrado nenhuma página destino. (page: ${page} - mode: ${mode}). Verifique se a página possui subPages e já foi carregada anteriormente!`);
      return;
    }

    subPages.forEach((pages) => {
      executeRecursiveCallbackInsideMultipage(state, {
        page: pages.name,
        mode: pages.mode,
        callback
      });
    });
  } else {
    callback( { page, mode });
  }
};

export const searchForAPropertyInChildPagesOfMultipage = (stateSchemes, { page, mode, prop }) => {
  if (!page || !mode || !prop) return { found: false };

  let result = { found: false, page, mode };

  if (mode === 'subPages') {
    let subPages = store.getters['page/subPages'](page);
    subPages.forEach((pages) => {
      let subResult = searchForAPropertyInChildPagesOfMultipage(stateSchemes, { page: pages.name, mode: pages.mode, prop });
      if (subResult.found) {
        result.found = true;
        result.page = pages.name;
        result.mode = pages.mode;
        return;
      }
    });
  } else {
    let schemaPage = stateSchemes[page][mode];
    result.found = (schemaPage.hasOwnProperty(prop) && schemaPage[prop]);
  }

  return result;
};

export const writeImagePathToCache = ({ page, mode, nameFileModel, keyModel }, { contextId=null, contextTypeId="contextTypeId" }) => {
  const currentPathFileList = sessionStorage.getItem('pathFileList') ? JSON.parse(sessionStorage.getItem('pathFileList')) : [];

  const keyPathFile = 'pathModel';
  const baseValueStringPathFile = `${page}.${mode}`;

  const indexContextItem = contextId ? store.state.page.models[page][mode]['context'].findIndex( item => item[contextTypeId] === contextId) : undefined;
  const stringPathFile = contextId ? `${baseValueStringPathFile}.context[${indexContextItem}].value` : `${baseValueStringPathFile}.${keyModel}`;

  // Verifica se o id já existe na lista de objetos, se sim, atualiza o valor do pathModel, se não, adiciona um novo objeto
  const index = currentPathFileList.findIndex( item => item.id === contextId ?? keyModel);
  if (index !== -1) {
    currentPathFileList[index][keyPathFile] = stringPathFile;
    currentPathFileList[index].fileName = nameFileModel;
  } else {
    currentPathFileList.push({
      [keyPathFile]: stringPathFile,
      id: contextId ?? keyModel,
      fileName: nameFileModel
    });
  };

  sessionStorage.setItem('pathFileList', JSON.stringify(currentPathFileList));
};

export const deleteImagePathToCache = (id) => {
  const currentPathFileList = sessionStorage.getItem('pathFileList') ? JSON.parse(sessionStorage.getItem('pathFileList')) : [];
  const index = currentPathFileList.findIndex( item => item.id === id);
  if (index !== -1) {
    currentPathFileList.splice(index, 1);
    sessionStorage.setItem('pathFileList', JSON.stringify(currentPathFileList));
  }
};

export const deletePropsFromModelByImagePathInCache = (referenceObject={}) => {
  const pathFileList = sessionStorage.getItem('pathFileList') ? JSON.parse(sessionStorage.getItem('pathFileList')) : [];

  if (pathFileList.length > 0) {
    pathFileList.forEach(imagePathCached => {
      const { pathModel } = imagePathCached;

      pathModel.split('.').reduce((obj, prop, index, array) => {
        if (!obj) return null;

        const [propName, propIndex] = prop.split('[');
        if (propIndex) {
          const index = propIndex.replace(']', '');
          return obj[propName] ? obj[propName][index] : null;
        }

        if (index === array.length - 1 && obj[prop]) {
          delete obj[prop];
        }

        return obj[prop];
      }, referenceObject);
    });
  }
};

export const clearSessionStorage = (sessionName, stateName) => {
  const persistedState = sessionStorage.getItem(sessionName);
  if (persistedState) {
    const stateObject = JSON.parse(persistedState);
    delete stateObject[stateName];
    const modifiedState = JSON.stringify(stateObject);
    sessionStorage.setItem('i4pro-portal', modifiedState);
  }
}

export const findParentComponent = (parent, component) => {
  while (parent) {
    if (parent.$options.name === component) {
      return parent;
    }

    parent = parent.$parent;
  }

  return null;
}

export const findChildComponent = (component, data, key) => {
  if (component.$options.propsData && component.$options.propsData[key] === data) {
    return component;
  }

  if (component.$children) {
    for (let child of component.$children) {
      const found = findChildComponent(child, data, key);
      if (found) {
        return found;
      }
    }
  }

  return null;
}
